import { Button } from '@/components/ui/button';
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from '@/components/ui/dialog';
import { useEffect, useState } from 'react';

export default function SessionExpiredModal() {
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        const handleSessionExpired = () => {
            setIsOpen(true);
        };

        window.addEventListener('session-expired', handleSessionExpired);

        return () => {
            window.removeEventListener('session-expired', handleSessionExpired);
        };
    }, []);

    const handleReload = () => {
        window.location.reload();
    };

    return (
        <Dialog open={isOpen} onOpenChange={setIsOpen}>
            <DialogContent
                className="sm:max-w-md"
                onPointerDownOutside={(e) => e.preventDefault()}
                onEscapeKeyDown={(e) => e.preventDefault()}
            >
                <DialogHeader>
                    <DialogTitle>Page expired</DialogTitle>
                    <DialogDescription>
                        The page has expired due to inactivity. Reload to
                        continue.
                    </DialogDescription>
                </DialogHeader>
                <DialogFooter className="sm:justify-end">
                    <Button onClick={handleReload} className="w-full sm:w-auto">
                        Reload page
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
